import type { NumberFormat, NumberSettings, NumberFormaterOptions } from '../types';
import { needsOverrideCurrency } from './needsOverrideCurrency';
import { needsOverrideMinimumFractionDigits } from './needsOverrideMinimumFractionDigits';
import { needsOverrideMaximumFractionDigits } from './needsOverrideMaximumFractionDigits';

/*
Собирает настройки вызова поверх настроек по умолчанию.
null означает, что переопределять нечего: форматтер по умолчанию подходит как есть
и пересоздавать его не нужно.
*/
export const buildOverriddenSettings = (
    format: NumberFormat,
    settings: NumberSettings,
    options?: NumberFormaterOptions,
): NumberSettings | null => {
    if (!options) {
        return null;
    }

    let overriddenSettings: NumberSettings | null = null;

    if (needsOverrideCurrency(format, settings, options.overrideCurrency)) {
        overriddenSettings = {
            ...settings,
            currency: options.overrideCurrency,
        };
    }

    if (needsOverrideMinimumFractionDigits(format, settings, options.minimumFractionDigits)) {
        overriddenSettings = {
            ...(overriddenSettings ?? settings),
            minimumFractionDigits: options.minimumFractionDigits,
        };
    }

    if (needsOverrideMaximumFractionDigits(format, settings, options.maximumFractionDigits)) {
        overriddenSettings = {
            ...(overriddenSettings ?? settings),
            maximumFractionDigits: options.maximumFractionDigits,
        };
    }

    return overriddenSettings;
};
